import React, { useEffect, useState } from 'react';
import  UserDatatable from '../../../components/admin/user/userDatatable';
import UserAddEditModal from '../../../components/admin/user/UserAddEditModal';
import { Button } from 'react-bootstrap';

const ListUsers: React.FC = () => {
    const [show, setShow] = useState(false);
    const [clientDetails, setClientDetails] = useState({ id: 0, firstName: '', lastName: '', phone: 0, email: '', orgId: 0 });
    const handleClose = () => setShow(false);

    const editModal = (make: any) => {
        setClientDetails(make)
        setShow(true)
    }

    const newClient = () => {
        setShow(true);
        setClientDetails({ id: 0, firstName: '', lastName: '', phone: 0, email: '', orgId: 0 })
    }
    return (
        <div id="wrapper">

            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <div className="container-fluid">
                        {/* <div className="d-sm-flex align-items-center justify-content-between">
                            <h2 className="mb-0 text-gray">Clients</h2>
                        </div> */}
                        <div>
                            <UserDatatable newClient={newClient} showModal={editModal} handleClose={handleClose} show={show} />
                            <UserAddEditModal show={show} handleClose={handleClose} clientDetails={clientDetails} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ListUsers;